import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=0ec3c61a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec3c61a')) {
      api.createRecord('0ec3c61a', component.options)
    } else {
      api.reload('0ec3c61a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=0ec3c61a&", function () {
      api.rerender('0ec3c61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qgF02LBOGV5d/JS/offershelp.vue"
export default component.exports